import { useState } from "react";
import { Wand2 } from "lucide-react";
import { evenSpread, likeLy, grow, sum, num, sel, btnS } from "./BpKit";

export const QuickFill = ({ rows, months, ly, onApply, disabled, weekly, tid = "bp-quick-fill" }) => {
  const [key, setKey] = useState(rows[0]?.key);
  const [total, setTotal] = useState("");
  const cur = rows.find((r) => r.key === key) || rows[0];
  const base = ly?.[cur?.key] || {};
  const hasLy = sum(base) > 0;
  const apply = (vals) => onApply(cur.key, vals);
  const t = num(total);
  return (
    <div className="flex flex-wrap items-end gap-2 p-3 bg-slate-50 border border-dashed border-slate-300 rounded-sm" data-testid={`${tid}-bar`}>
      <div className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-slate-500 mr-1"><Wand2 className="h-3.5 w-3.5" />Quick fill</div>
      <select data-testid={`${tid}-row`} className={sel} value={cur?.key} onChange={(e) => setKey(e.target.value)} disabled={disabled}>
        {rows.map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
      </select>
      <input data-testid={`${tid}-total`} type="number" min="0" step="any" placeholder={weekly ? "Per week" : "Annual total"} value={total}
        onChange={(e) => setTotal(e.target.value)} disabled={disabled} className={`${sel} w-32 num`} />
      {weekly ? (
        <button type="button" data-testid={`${tid}-same-button`} className={btnS} disabled={disabled || !t} onClick={() => apply(Object.fromEntries(months.map((m) => [m, t])))}>Same every month</button>
      ) : (
        <>
          <button type="button" data-testid={`${tid}-even-button`} className={btnS} disabled={disabled || !t} onClick={() => apply(evenSpread(t, months))}>Even spread</button>
          <button type="button" data-testid={`${tid}-trend-button`} className={btnS} disabled={disabled || !t || !hasLy} onClick={() => apply(likeLy(t, base, months))}
            title={hasLy ? "Split the total the way last year's months went" : "No last-year numbers for this row"}>Like last year's months</button>
        </>
      )}
      {!weekly && hasLy && [10, 15, 20].map((g) => (
        <button key={g} type="button" data-testid={`${tid}-grow-${g}`} className={btnS} disabled={disabled} onClick={() => apply(grow(base, months, g))}>LY +{g}%</button>
      ))}
    </div>
  );
};
